// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
    IonButton,
    IonButtons,
    IonContent,
    IonGrid,
    IonItem,
    IonLabel,
    IonModal,
    IonRow,
    IonText,
    IonToolbar
  } from "@ionic/react"
  import { useState } from "react"
  import { useLocales } from "react-localized"
  import { SingleValue } from 'react-select'
  import AsyncSelect from "react-select/async"
  import { ResponsiveIonCol } from "./ResponsiveIonCol"
  
  
interface ModalProps {
  close(): void
  isOpen: boolean
  loadOptions(): Promise<{value: any, label: string}[]>,
  onSelected(value: any): void
}


const SelectLocationModal: React.FC<ModalProps> = ({
  close,
  isOpen,
  loadOptions,
  onSelected
}) => {
  const {gettext} = useLocales()
  return (
    <IonModal animated={false} backdropDismiss={false} className="page-modal" isOpen={isOpen}>
      <IonContent>
        <main>
          <IonGrid>
            <IonRow>
              <ResponsiveIonCol>
                <IonText>
                <p style={{marginBottom: "22px"}}>{gettext("Choose a Location from the list below.")}</p>
                </IonText>
                <IonText>
                  <AsyncSelect
                      cacheOptions
                      classNames={{
                        container: (state) => "select-container",
                        control: (state) => "control",
                        indicatorsContainer: (state) => "indicators",
                        menuList: (state) => "menu-list",
                        menu: (state) => "menu",
                        option: (state) => (!!state.isFocused) ? "focus" : "",
                        placeholder: (state) => "placeholder",
                        singleValue: (state) => "current-value",
                        valueContainer: (state) => "value-container"
                      }}
                      defaultOptions 
                      onChange={(option: SingleValue<any>) => {
                        onSelected(option)
                      }}
                      loadOptions={loadOptions}
                  />
                </IonText>
              </ResponsiveIonCol>
            </IonRow>
          </IonGrid>
        </main>
      </IonContent>
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton color="medium" onClick={() => {
            close()
          }}>
            {gettext("Cancel")}
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonModal>
  )
}

const SelectLocationItem: React.FC<{
  loadOptions(): Promise<{value: any, label: string}[]>,
  onSelected(value: any): void,
  placeholder: string,
  value: any
}> = ({
  loadOptions,
  onSelected,
  placeholder,
  value
}) => {
  const {gettext} = useLocales()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <>
      <IonItem
        className="clickable"
        detail={true}
        lines="full"
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <IonLabel>
          <h2>{gettext("Location")}</h2>
          <p>{placeholder}</p>
        </IonLabel>
      </IonItem>
      <SelectLocationModal
        close={() => { setIsOpen(false) }}
        isOpen={isOpen}
        loadOptions={loadOptions}
        onSelected={(value: any) => {
          onSelected(value)
          setIsOpen(false)
        }}
      />
    </>
  )
}


export { SelectLocationItem, SelectLocationModal }